<template>
  <div class=" mt-5 ">
    <v-layout row wrap>
      <v-flex>
        <section>
          <div>
            <div class="text-center ">
              <div class="fs-24 font_weight_600 black_one">
                Apa jenis usaha Anda?
              </div>

              <div class="black_three mt-1">
                Pilih salah satu jenis kategori yang sesuai dengan usaha Anda
              </div>
            </div>


            <div class="mt-1">
              <v-row justify="center">
                <v-col cols="6">
                  <v-card class="box-shadow">
                    <v-card-text
                      v-if="process.load"
                      class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>
                    <v-card-text class="pa-6" v-if="!process.load">
                      <v-row>
                        <v-col cols="6" v-for="(item, index) in jenis" :key="index">
                          <v-card flat @click="form.jenis_usaha = item.business_type_name" :style="item === form.jenis_usaha ? 'border: 1px solid #906CF6; border-radius: 8px; background: #E9E5F3;' : 'border: 1px solid #D4D4D4; border-radius: 8px;'">
                            <v-card-text class="d-flex align-center py-7" style="color: #404040;">
                              <v-radio-group v-model="form.jenis_usaha" dense hide-details class="mt-0">
                                <v-radio
                                  :value="item.business_type_name"
                                  color="black"
                                  class="">
                                </v-radio>
                              </v-radio-group>
          
                              <div class="fs-13">
                                {{ item.business_type_name }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text style="background: #FAFAFA" class="px-6 py-4 text-right">
                      <v-btn
                        color="#240087"
                        height="36"
                        width="95"
                        elevation="0"
                        :loading="process.form"
                        :to="`/register/informasi-usaha/${$route.params.id}?usaha=${form.jenis_usaha.split(' ').join('-')}`"
                        style="border-radius: 6px;"
                        :disabled="process.form || form.jenis_usaha === ''"
                        class="white--text text-capitalize">
                        Lanjut
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        jenis: ['Praktik Dokter Mandiri', 'Klinik Kecantikan', 'Kuliner, Resto atau Cafe', 'Toko Kelontong atau Ritel', 'Kost atau Penginapan', 'Ruang Usaha atau Meeting Room', 'Klinik Kesehatan atau Kebidanan', 'Jenis Lainnya'],
        process: {
          form: false,
          load: true
        },
        form: {
          jenis_usaha: ''
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          limit: 10000000
        }

        await get(`business_type/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.jenis = res.results.data
          }
        })
      },
    }
  }
</script>